import React from 'react';
import { useTranslation } from 'react-i18next';

import PageLayout from '@/components/layout/PageLayout';
import Table from '@/components/ui/tables/Table';
import { AuditFiltersCard } from '@/components/features/audit/AuditFiltersCard';
import { useAuditList } from '@/hooks/audit/useAuditList';


export const AuditRecordsList: React.FC = () => {
  const { t: translate } = useTranslation();
  const {
    rows,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    loading,
    isSearching,
    canSearch,
    columns,
    expandable,
    pendingFilters,
    setPendingFilters,
    handleSearch,
    onSearch,
    onSortChange,
    entitiesOptions,
    programsOptions,
    actionsOptions,
    usersOptions,
    combosLoaded,
    isExporting,
    onExport,
  } = useAuditList();

  return (
    <PageLayout>
      <div className="flex flex-col gap-4" data-testid="audit-list-page">

        <AuditFiltersCard
          pendingFilters={pendingFilters}
          setPendingFilters={setPendingFilters}
          entitiesOptions={entitiesOptions}
          programsOptions={programsOptions}
          actionsOptions={actionsOptions}
          usersOptions={usersOptions}
          combosLoaded={combosLoaded}
          isSearching={isSearching}
          canSearch={canSearch}
          handleSearch={handleSearch}
          isExporting={isExporting}
          onExport={onExport}
        />

        <Table
          columns={columns}
          data={rows}
          totalRows={total}
          isLoading={loading}
          searchable
          onSearch={onSearch}
          serverSideSort
          initialSort={{ key: 'date', direction: 'desc' }}
          onSortChange={onSortChange}
          pagination={{
            page,
            pageSize,
            total,
            onChange: setPage,
            onPageSizeChange: setPageSize,
          }}
          expandable={expandable}
          data-testid="audit-records-table"
          emptyMessage={translate('audit:messages.noResults')}
        />
      </div>
    </PageLayout>
  );
};

export default AuditRecordsList;

